import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchTemplates } from '../api/export-charging-sessions.api'

import { TemplatesModel } from '../models/pdf-template.model'
import { useTypedSelector } from 'src/State/RootReducer'
import { MOCK_EXPORT_TEMPLATES } from 'src/Libs/e-mobility/guided-tour'
import { usePortalQuery } from 'src/Libs/api'

interface UseTemplatesHook {
  isLoading: boolean
  isFetching: boolean
  isFetched: boolean
  templates: TemplatesModel[]
}

interface UseTemplatesParams {
  installationId: number
}

const staleTime = 10 * 60 * 1000 /** pdf template will rarely get updated, if updated at all. Refetch only if data is older than 10 minutes */

/**
 * A prerequisite for PDF export of charging sessions from HagerBridge backend is that the database contains
 * at least one HTML template that was manually uploaded via Swagger.
 *
 * This hook fetches the list of all PDF templates(HTML templates, to be exact, they are populated on
 * backend side and then converted to PDF). At the moment, backend is such that we must filter the list
 * of all templates, find the default one, take its "templateUuid" and provide it in every network request for
 * downloading the PDF report.
 */

export const usePDFTemplates = ({ installationId }: UseTemplatesParams): UseTemplatesHook => {
  const authFetch = useAuthFetchWithResult()
  const eMobilityTourRunning = useTypedSelector(state => state.eMobility.tour.isRunning)

  const {
    data: templates,
    isLoading,
    isFetched,
    isFetching,
  } = usePortalQuery({
    queryFn: () => (eMobilityTourRunning ? Promise.resolve(MOCK_EXPORT_TEMPLATES) : fetchTemplates({ installationId, authFetch })),
    queryKey: ['templates', installationId],
    staleTime,
  })

  return {
    templates: templates ?? [],
    isLoading,
    isFetched,
    isFetching,
  }
}
